﻿$(function () {
    var fixedRow = $('.fixed-row.follow-user-inside-column-space');
    var notFixedElement = $('.fixed-row > .not-fixed-column');
    var fixedElement = $('.fixed-row > .fixed-column');
    var submenu = $('body > .sf_colsIn > .header-with-placeholder-top.stick-to-page-top-and-hide-on-scroll');
    var menu1 = $('.jnf-widget.jnf-widget-menu-1');
    var positionFromLeft;

    if (menu1.length > 0) {
        var menuHeight = menu1[0].offsetHeight;
        var sfContainer = $('#sfPageContainer');

        if (sfContainer.length == 0 && fixedRow.length > 0) {

            $(window).on('scroll', function () {
                fixedRow.each(function (index) {
                    var diff = fixedRow[index].offsetHeight - fixedElement[index].offsetHeight;
                    var fixedElementWidth = fixedRow.width() * 0.333;
                    if (submenu.css('position') === 'fixed' || submenu.css('top') >= $(window).scrollTop()) {
                        menuHeight = submenu[0].offsetHeight;
                    }
                    else {
                        menuHeight = menu1[0].offsetHeight;
                    }
                    if (($(window).scrollTop() + menuHeight) > fixedRow[index].offsetTop && fixedRow[index].offsetTop > $(window).scrollTop() - diff && fixedRow[index].offsetHeight + fixedRow[index].offsetTop - $(window).scrollTop() >= fixedElement[index].offsetHeight + menuHeight) {
                        positionFromLeft = fixedRow[index].offsetLeft + fixedRow[index].offsetWidth - fixedElementWidth;
                        $(fixedElement[index]).css('position', 'fixed').css('top', menuHeight).css('left', positionFromLeft).css('width', fixedElementWidth);

                    }
                    else if ($(window).scrollTop() + menuHeight >= fixedRow[index].offsetTop + diff && $(window).scrollTop() + menuHeight < fixedRow[index].offsetTop + fixedRow[index].offsetHeight) {

                        $(fixedElement[index]).css('position', 'absolute').css('top', diff).css('left', notFixedElement[index].offsetWidth);

                    }
                    else {
                        $(fixedElement[index]).addClass('').css('left', '0').css('top', '0');

                    }
                });
            });
            $(window).on('resize', function () {
                positionFromLeft = fixedRow[index].offsetLeft + fixedRow[index].offsetWidth - fixedElementWidth;
                
            });

        }
    }

});